import type { BRCYCodes } from "brandRegionConfig";
import { getBrand } from "core/utils/getBrand";
import { useRegion } from "./useRegion";

export function useBrcyCode() {
  const countryIso2AlphaCode = useRegion();
  const { brandTwoLetterCode } = getBrand();
  return `${brandTwoLetterCode}${countryIso2AlphaCode}`.toUpperCase() as BRCYCodes;
}
